import MAD from "../mad-engine";
import { easeInCubic, easeInQuart, easeOutCubic, easeOutQuad, easeInQuint } from "./ease";
import SimplexNoise from "./simplexNoise";
import { gsap } from "gsap";

export default class NoiseReader{
    constructor(audioPlayer){
        this.noise = new SimplexNoise();
        this.scale = 0.008;
        this.amplitude = 0;
        this.progress = 0;
        this.speed = 0;
        this.time = 0;
        this.audioPlayer = audioPlayer;
        this.state = null;
        this.states = [
            {
                time: 21.33,
                action: () => gsap.to(this,{speed:50, amplitude: 0, duration: 18})
            },
            {
                time: 41.33,
                action: () => gsap.to(this,{speed:100, amplitude: 1, duration: 1.5})
            },
            {
                time: 85.33,
                action: () => gsap.to(this,{speed:30, amplitude: 0, duration: 0.3})
            },
            {
                time: 96,
                action: () => gsap.to(this,{speed:50, amplitude: 0.5, duration: 0})
            },
            {
                time: 106,
                action: () => gsap.to(this,{speed:100, amplitude: 1, duration: 1})
            },
            {
                time: 149.33,
                action: () => gsap.to(this,{speed:30, amplitude: 0, duration: .3})
            },
            {
                time: 173.33,
                action: () => gsap.to(this,{speed:40, amplitude: 0, duration: .3})
            },
            {
                time: 176,
                action: () => gsap.to(this,{speed:60, amplitude: 0, duration: .3})
            },
            {
                time: 178.66,
                action: () => gsap.to(this,{speed:80, amplitude: 0, duration: .3})
            },
            {
                time: 181.33,
                action: () => gsap.to(this,{speed:100, amplitude: 0, duration: .3})
            },
            {
                time: 184,
                action: () => gsap.to(this,{speed:200, amplitude: 0, duration: 11})
            },
            {
                time: 205,
                action: () => gsap.to(this,{speed:500, amplitude: 0, duration: 0})
            },
            {
                time: 248,
                action: () => gsap.to(this,{speed:100, amplitude: 1, duration: 0})
            },
            {
                time: 269.33,
                action: () => {
                    gsap.to(this,{amplitude: 0, duration: 0})
                    gsap.to(this,{speed: 0, duration: 2})
                }
                
            }
        ];
    }

    start(){
        this.audioPlayer.play(19);
        MAD.App.instance.updateListeners.push(() =>{
            const { clock, inputs } = MAD.App.instance;
            this.time += clock.delta;
            let current = null;
            for(let state of this.states){
                if(state.time < this.audioPlayer.time()){
                    current = state;
                }
            }

            if(current != this.state){
                current.action();
                this.state = current;
            }
         
            this.progress += this.getSpeed();
        });
    }

    getProgress(){
        return this.progress;
    }

    getCurve(){
        return this.noise.noise2D( -this.getProgress() * .001, 0);
    }

    getSpeed(){
        const { clock } = MAD.App.instance;
        return clock.delta * this.speed;
    }

    read(z){
        const bpm = 90/60;
        const value = this.speed <= 0 ? 0 : 2 * Math.PI * bpm/this.speed;
        const sin = Math.sin(value * (z - this.getProgress())  - Math.PI * .5);
        const pulse = easeInQuint((sin + 1) * 0.5) * this.amplitude;
        return pulse + this.noise.noise2D((z - this.getProgress()) * 0.002, 0) * 10;
    }
}